import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
    Card,
    CardContent,
    Grid,
    Paper, Snackbar,
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow, Typography
} from "@mui/material";
import {Circle, CopyAll, Email, FileCopy, LinkOff, LinkRounded} from "@mui/icons-material";
import {Alert} from "@mui/lab";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import {useState} from "react";

function FileCopyIcon() {
    return null;
}

export default function SupplyFeedsModal({open,setOpen, row}) {

    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(
            () => {
                console.log('Copied to clipboard');
                setSnackbarOpen(true);
            },
            (err) => {
                console.error('Failed to copy text: ', err);
            }
        );
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen(false);
    };

    return (
        <div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Supply Feeds of Demand {row?.id}
                    <Alert severity="info" sx={{mt: 2, display: "flex"}}><strong>Test Link: </strong>https://srchbay.com/testlink/{row?.id} </Alert>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="supply feeds table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Active</TableCell>
                                        <TableCell>Supply User</TableCell>
                                        <TableCell>CAP</TableCell>
                                        <TableCell>Anti. Fraud %</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row?.supply_feeds?.map((item) => (
                                        <TableRow key={item.id}>
                                            <TableCell>{item.id}</TableCell>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell>
                                                <Circle color={item.active ? 'success' : 'error'} fontSize={'small'} />
                                            </TableCell>
                                            <TableCell>{item.user.name}</TableCell>
                                            <TableCell>{item.capping}</TableCell>
                                            <TableCell>{item.antifraud_check}</TableCell>
                                            <TableCell>
                                                <IconButton
                                                    edge="end"
                                                    color="inherit"
                                                    onClick={() =>
                                                        handleCopyToClipboard(
                                                            `Name: ${item.name}
Tracking Url: https://${item.domain.domain}/track/${item.id}/?q={keyword}
Device: ${
                                                                item.demand[0].desktop && item.demand[0].mobile ? "Mobile and Desktop" :
                                                                    !item.demand[0].desktop && item.demand[0].mobile ? "Mobile" :
                                                                        item.demand[0].desktop && !item.demand[0].mobile ? "Desktop" :
                                                                            ''
                                                            }
CAP: ${item.capping} searches/day
-----------
>> Extra macros: {click_id} *required for postback
${item.demand[0].type.name == "BHS" ? ">> Benchmarks: Ad Coverage >80%; CTR 8-11%; FOS: 9-12% Do NOT send too much traffic and follow the cap provided above. \n" +
                                                                ">> We may also be forced to stop if invalid, automated or fake traffic detected. \n" +
                                                                "**Note: If all looks good, we are able to increase the cap or provide new feeds.  :)":">> Benchmarks: Ad Coverage >80%; CTR 20-40%; Do NOT send too much traffic and follow the cap provided above.\n" +
                                                                ">> We may also be forced to stop if invalid, automated or fake traffic detected.\n" +
                                                                "**Note: If all looks good, we are able to increase the cap or provide new feeds.  :)"}`
                                                        )
                                                    }
                                                >
                                                    <CopyAll />
                                                </IconButton>

                                                <IconButton
                                                    edge="end"
                                                    color="inherit"
                                                    onClick={() =>
                                                        handleCopyToClipboard(`https://${item.domain.domain}/track/${item.id}/?q={keyword}`)
                                                    }
                                                >
                                                    <LinkRounded />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>



                    </DialogContentText>
                </DialogContent>
                {/*<DialogActions>*/}
                {/*    <Button onClick={handleClose}>Disagree</Button>*/}
                {/*    <Button onClick={handleClose} autoFocus>*/}
                {/*        Agree*/}
                {/*    </Button>*/}
                {/*</DialogActions>*/}
            </Dialog>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    Copied to clipboard!
                </Alert>
            </Snackbar>
        </div>
    );
}